import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-72651d13"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "calc-title"
};
var _hoisted_2 = {
  class: "input-screen"
};
var _hoisted_3 = {
  class: "numeric-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_col = _resolveComponent("el-col");

  var _component_SvgIcon = _resolveComponent("SvgIcon");

  var _component_el_button = _resolveComponent("el-button");

  var _component_el_row = _resolveComponent("el-row");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_row, {
    type: "flex",
    justify: "start",
    class: "input-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 18,
        offset: 1
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("calculator.insert-quantity")), 1), _createElementVNode("p", _hoisted_2, [_withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _ctx.inputContent = $event;
            })
          }, null, 512), [[_vModelText, _ctx.inputContent]])])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 2
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            class: "erase-button",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.eraseFromInput();
            })
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_SvgIcon, {
                iconContent: _ctx.iconContent,
                iconAlt: _ctx.iconAlt,
                iconStyle: _ctx.iconStyle
              }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_row, {
    type: "flex",
    justify: "start",
    class: "buttons-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["1"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("1")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["2"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("2")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["3"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("3")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    type: "flex",
    justify: "start",
    class: "buttons-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["4"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("4")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["5"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("5")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["6"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("6")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    type: "flex",
    justify: "start",
    class: "buttons-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["7"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("7")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["8"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("8")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["9"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("9")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_el_row, {
    type: "flex",
    justify: "start",
    class: "buttons-wrapper"
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.updateInput,
            onKeydown: _withKeys(_ctx.updateInput, ["0"]),
            class: "calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode("0")];
            }),
            _: 1
          }, 8, ["onClick", "onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return _ctx.$emit('closeCalc');
            }),
            onKeydown: _withKeys(_ctx.updateInput, ["0"]),
            class: "calc-button hide-btn"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_SvgIcon, {
                iconContent: _ctx.hideIcon,
                iconAlt: _ctx.hideIconAlt,
                iconStyle: _ctx.hideIconStyle
              }, null, 8, ["iconContent", "iconAlt", "iconStyle"])];
            }),
            _: 1
          }, 8, ["onKeydown"])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 8
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_button, {
            onClick: _ctx.clearInput,
            class: "clear-btn calc-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("calculator.clear").toUpperCase()), 1)];
            }),
            _: 1
          }, 8, ["onClick"])];
        }),
        _: 1
      })];
    }),
    _: 1
  })])], 64);
}